import { ConfiguredColumn, EntityType } from '@types'

type Props = {
  entity: EntityType
  column: ConfiguredColumn
  globalStylesNames: { header: string; text: string }
  entityStylesNames: { header: string; text: string }
  columnStylesNames: { header: string; text: string }
}

export const getHeaderClassName = (props: Props) => {
  const { entity, column, globalStylesNames, entityStylesNames, columnStylesNames } = props

  if (column.useLocalParameters) {
    return columnStylesNames.header
  }

  if (entity.useLocalParameters) {
    return entityStylesNames.header
  }

  return globalStylesNames.header
}
